import { observer } from 'mobx-react-lite';
import { Page } from '../../components';
import ApiWidget from './components/ApiWidget';

export default observer(function DebugPage() {
  return (
    <Page>
      <ApiWidget />
    </Page>
  );
});
